import { httpClient } from '../httpClient/httpClient';

export interface InternalApiKey {
  id: number;
  name: string;
  issuedByUserId: number;
  issuedByUserName: string;
  createdAt: string;
  revokedAt: string | null;
}

export interface IssuedInternalApiKey {
  id: number;
  name: string;
  apiKey: string;
  createdAt: string;
}

export const internalApiKeysApi = {
  getAll: () => httpClient.get<InternalApiKey[]>('internal-api-keys'),
  issue: (name: string) =>
    httpClient.post<IssuedInternalApiKey>('internal-api-keys', {
      data: { name },
    }),
  revoke: (id: number) =>
    httpClient.post<void>(`internal-api-keys/${id}/revoke`),
  reactivate: (id: number) =>
    httpClient.post<void>(`internal-api-keys/${id}/reactivate`),
};
